<template>
  <div>
    <div class="w-all w-minw bd-sd-b hg-40 bg-c-ffffff">
      <div class="w-main m-auto">
        <div class="fr">
          <div class="hover-ucenter fl">
            <div class="top_ucenter fl fs-12 line-h40"></div>
          </div>

          <a class="fs-12 ftc-000000 line-h40 go-login more" href="/show" v-if="nickname!=null">
            <i class="iconfont icon-member p-l-20 hg-40 fl m-r-6"></i>
            您好，{{nickname}}
          </a>
          <a
            class="fs-12 ftc-000000 line-h40 go-login more"
            href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=http://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
            v-if="nickname==null"
          >
            <i class="iconfont icon-member p-l-20 hg-40 fl m-r-6"></i>您好，请登录
          </a>
          <a href="javascript:void(0)" @click="logout" v-if="nickname!=null" class="fs-12 ftc-000000 line-h40 m-l-4 more">[退出]</a>
          <a href="/login" v-if="nickname==null" class="fs-12 ftc-000000 line-h40 m-l-4 more"></a>
          <span class="fs-12 ftc-000000 line-h40 m-l-15">|</span>

          <div class="fr m-l-15">
            <div class="my-lesson">
              <a v-if="nickname!=null" href="/cglist" class="fl fs-12 ftc-000000 line-h40">
                <i class="iconfont icon-play1 m-r-4"></i>作品列表
              </a>
              <a
                v-if="nickname==null"
                href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=http://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
                class="fl fs-12 ftc-000000 line-h40"
              >
                <i class="iconfont icon-play1 m-r-4"></i>作品列表
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>

    <div class="toppic wall mb10">
      <div class="picself wall">
        <ul>
          <li>
            <a href="/Show">首页</a>
          </li>

          <li>
            <a href="/cgzp">课改成果展评</a>
          </li>
          <li>
            <a href="/lwzp">原创成果展评</a>
          </li>
          <li>
            <a href="/lwList">上传作品</a>
          </li>
          <li>
            <a href="/hjcx">获奖查询</a>
          </li>
        </ul>

        <!-- <a class="uploadfile"  href="/bmcs">上传作品</a> -->
      </div>
    </div>
    <div class="main w1200">
      <div class="w1200">
        
        <div class="bg">
          <div style="text-align: center;">

          
          <p class="f16" style=" padding:30px 30px;">如果您在语文教育领域已有公开的课改成果，欢迎您参加——</p>
     
            <img id="cgzp" src="../assets/images/title_cgzp.png" />
  
          </div>
          <p class="f14 of" style="padding:30px 45px;font-size:17px">
            <b>一、征稿对象</b>
            <br />面向所有小学、中学、大学的语文教学教研工作者。
            <br />
            <b>二、征稿说明</b>
            <br />1.参评学术成果应符合新时代课改精神。
            <br />2.参评学术成果包括论文、专著(含编著)、课题、获奖公开课等。
            <br />3.参评学术成果必须与语文教育有关，可以体现在课标研究、教材研究、教法探讨、教学设计、课堂展示、课外拓展、教学反思、考试评价等语文教学与研究的各个环节。
            <br />
            <b>三、参评要求</b>
            <br />1.凡在2026年6月30日前，5年内取得以下学术成果者均可申报： 
            <br />（1）已在专业报刊发表的学术论文。 
            <br />（2）正式出版的学术专著（含编著）。 
            <br />（3）已验收的市级以上学术课题。 
            <br />（4）在省级以上评比中获奖的公开课。 
            <br />以上学术成果有县级以上行政部门或学术团体的正式推荐意见者，优先参评。 
            <br />2.参评者综合素养要求：学科知识扎实，专业能力突出，教育情怀深厚，学术影响较大。 
            <br />
            <b>四、参评办法</b>
            <br />参评者可以选择个人申报，也可以由所在县级以上教研室、语文类学会推荐。 
            <br />1. 需要提交的材料 
            <br />（1）符合“参评要求”的学术成果证明材料（扫描件）。注意：专著（含编著）原则上须将原书寄送组委会，扫描件应不少于二分之一内容（目录、序跋必须完整）。 
            <br />（2）500字左右个人小传，主要介绍个人学术道路与5年之内取得的学术成果。 
            <br />（3）职称证书复印件，或个人身份证复印件、教师资格证复印件。 
            <br />2. 注意事项 
            <br />（1）以上所有材料扫描后制成PDF文件，上传至语文报社官网语文网专用通道https://xspx.zhyww.cn/（需通过电脑端报名参评），点击“新时代语文教育课改成果展评”端口，完成相关申报、信息采集和材料上传流程。 
            <br />（2）起止时间：2026年3月15日—11月30日。
     
            <br />
            <b>五、评奖程序</b>
            <br />1.2026年10月，由评委会对所有申报材料进行初审，并采取无记名投票的方式，评出初选优秀成果。 
            <br />2.2026年11月，评委会组织专家对初选优秀成果作品进行打分，确定学术成果获奖等级。 
            <br />3.2026年12月，《语文教学通讯·学术刊》、语文网和中国知网将同时公布获奖名单。 
            <br />
            <b>六、参评须知</b>
            <br />1.本次课改成果展评按论文、专著（含编著）、课题、获奖公开课分为四组，各组分设特等奖、一等奖、二等奖和优秀奖四个奖次。 
            <br />2.获奖者均颁发加盖中国语文报刊协会、语文报社、语文报社基础教育研究院、《语文教学通讯·学术刊》公章的特制荣誉证书。获奖者将有机会受邀参加“语文报杯”全国中青年教师课堂教学大赛学术论坛，并被聘为语文报社基础教育研究院讲席专家。 
            <br />3. 特别优秀的获奖者，还将作为《语文教学通讯·学术刊》封面人物予以专栏介绍。
            <br />4.本活动为公益活动，不收取任何费用。 
 
            <br />
          </p>
          <div class="mb30" style="width:321px;margin:0 auto;">
            <!-- <a hover="hand">
              <img id="baoming_y" @click="toChengGuo" src="../assets/images/baoming_y.png" />
            </a>-->
            <a
              v-if="nickname==null"
              href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=http://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
              hover="hand"
            >
              <img id="baoming_y" src="../assets/images/baoming_y.png" />
            </a>
           
              <img v-if="nickname!=null" id="baoming_y" src="../assets/images/baoming_y.png"  @click="toCglist"/>
            
          </div>
        </div>
      </div>
    </div>
    <div
      class="footer"
      style="background:url(('../../assets/images/foot.png')) top center no-repeat;"
    >
      <div class="menu">
        <div class="box">
          <a href="http://www.zhyww.cn/ywbs/bsjj/202006/115472.html" target="_blank">关于我们</a>&nbsp;|&nbsp;
          <a
            href="http://www.zhyww.cn/ywbs/bsjj/202006/115483.html"
            target="_blank"
          >联系我们</a>&nbsp;|&nbsp;
          <a
            href="http://www.zhyww.cn/ywbs/bsjj/202006/115484.html"
            target="_blank"
          >版权声明</a>
        </div>

        <div class="copyright">
          <p>语文网版权所有 未经书面授权 不得复制或建立镜像 晋公网安备14010902000073号</p>
          <p>
            增值电信业务经营许可证晋B2-20030007 新出网许（晋）字005号
            <a
              href="http://beian.miit.gov.cn/publish/query/indexFirst.action"
              target="_blank"
            >晋ICP备09011058号</a>
            <a
              href="http://webscan.360.cn/index/checkwebsite/url/www.zhyww.cn"
              name="f7c1c8d71288f01cb16d63638e8f82bc"
            >网站安全检测平台</a>
          </p>
        </div>

        <a href="http://webscan.qianxin.com/safe/detail/?query=www.zhyww.cn">
          <img
            border="0"
            src="http://webscan.qianxin.com/api/authcode?code=fd753cb81c61b4824c3645292d170f85"
            style="display: none;"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/base.css";
import "@/assets/xspx.css";
export default {
  data() {
    return {
      nickname: null,
      username:null
    };
  },
  created() {
    var openid = sessionStorage.getItem("openid");
    // if(openid == null){
    //   this.$router.push({ path: "/" });
    // }
    this.nickname = sessionStorage.getItem("nickname");
   
  },
  methods: {
    close: function() {
      this.$alert("活动已结束", "", {
        confirmButtonText: "确定"
      });
    },
    toCglist(){
      var that = this;
      var name = sessionStorage.getItem("username");
      console.log("that.username:"+name)
      if(name == 0){
            that.$router.push({ path: "/userHome" });
      }else {
            that.$router.push({ path: "/cgList" });
      }
    },
     logout(){
    sessionStorage.clear();
     this.$router.push({ path: "/" });
  }
  }
};
</script>
